<template>
  <ul-page higher :fullHeader="false" class="page-course">
    <template v-slot:right>
      <div class="page-header-right">
        <LoginUser></LoginUser>
      </div>
    </template>
    <div class="page-top" :style="{'background': getBg() }">
      <div class="page-top-shadow">
        <div class="content">
          <div class="course-content">
            <div class="cover-wrapper">
              <div class="image-wrapper" v-if="!course.briefdesc">
                <img v-if="nationalQualityCourse.includes(course.textbookId)" class="national-flag" src="@/assets/images/jpk.gif" alt="">
                <img :src="course.cover | fullpath" alt="" class="cover">
              </div>
              <div class="video-wrapper" v-else>
                <video :id="'video-media'" width="480px" height="270px" :poster="course.cover | fullpath" playsinline webkit-playsinline class="custom-video">
                  <source type="video/mp4" :src="course.briefdesc | fullpath"  />
                </video>
              </div>
            </div>
            <div class="course-info">
              <div class="title-wrapper">
                <div class="title">{{course.name}}</div>
                <ul-popover
                  placement="bottom"
                  width="480"
                  trigger="hover"
                  >
                  <div class="course-share">
                    <div class="title">分享课程</div>
                    <div class="tips">扫码或复制链接分享</div>
                    <div class="qrcode-wrapper" ref="qrCode"></div>
                    <div class="url">{{textbookPortalUrl}}</div>
                    <el-tooltip content="复制成功" placement="top" :manual="true" v-model="copied">
                      <ul-button plain size="mini" @click="copyShareUrl">复制</ul-button>
                    </el-tooltip>
                  </div>
                  <span slot="reference"><i class="iconfont icon-fenxiang2 share"></i></span>
                </ul-popover>
              </div>
              <div class="tags-wrapper">
                <div class="tag" v-for="(item, index) in course.tags" :key="index">{{item}}</div>
              </div>
              <div class="course-info-items">
                <div class="info-item">
                  <i class="iconfont icon-kaikeyuanxiao"></i>
                  <span class="label">开课院校：</span>
                  <span class="item-content">{{course.openCourseSchool}}</span>
                </div>
                <div class="info-item">
                  <i class="iconfont icon-shiyongzhuanye"></i>
                  <span class="label">适用专业：</span>
                  <span class="item-content">{{course.suitMajor}}</span>
                </div>
                <div class="info-item">
                  <i class="iconfont icon-jianyixueshi"></i>
                  <span class="label">建议学时：</span>
                  <span class="item-content">{{course.recommendStudytime}}课时</span>
                </div>
              </div>
              <div class="data-area">
                <div class="data-item">
                  <i class="iconfont icon-leijixuankerenshu"></i>
                  <div class="data-info">
                    <div class="num">{{course.studentCount || 0}}</div>
                    <div class="label">
                      <div class="text">累计选课人数</div>
                      <el-tooltip content="课程累计选课人数，包括校内外各期SPOC人数及自主选课学生人数，数据每天更新一次" placement="bottom" effect="light">
                        <i class="iconfont icon-jieshiyiwen"></i>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="data-item">
                  <i class="iconfont icon-xuankexuexiaozongshu"></i>
                  <div class="data-info">
                    <div class="num">{{course.schoolCount || 0}}</div>
                    <div class="label">
                      <div class="text">选课学校总数</div>
                      <el-tooltip content="选用该课程的学校总数，数据每天更新一次" placement="bottom" effect="light">
                        <i class="iconfont icon-jieshiyiwen"></i>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="data-item">
                  <i class="iconfont icon-yemianliulancishu"></i>
                  <div class="data-info">
                    <div class="num">{{course.viewCount || 0}}</div>
                    <div class="label">
                      <div class="text">课程学习次数</div>
                      <el-tooltip content="课程主页浏览次数+课程学习人次总和，数据每天更新一次" placement="bottom" effect="light">
                        <i class="iconfont icon-jieshiyiwen"></i>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="course-times">
            <div class="terms-wrapper" v-if="course.isCharge && course.terms && course.terms.length > 0">
              <ul-select v-model="currentTerm" value-key="id" placeholder="请选择" @change="termChange">
                <ul-option
                  v-for="(item, index) in course.terms"
                  :key="item.value"
                  :label="termTitle(item, index)"
                  :value="item"
                  :disabled="item.disabled">
                </ul-option>
              </ul-select>
              <div class="status">{{getTermStatusText()}}</div>
            </div>
            <div class="tips" v-if="course.isCharge && course.terms && course.terms.length == 0">本课程未设置学期，你可以加入课程自主学习</div>
            <div class="tips" v-if="!course.isCharge">本课程不支持自主加入</div>
            <ul-button type="primary" v-if="(course.isCharge && course.terms && course.terms.length == 0) || (course.isCharge && course.terms && course.terms.length > 0 && currentTerm.status == 2)" @click="toTextbook">{{toTextbookMap[toTextbookType]}}</ul-button>
            <ul-button type="primary" disabled v-if="course.isCharge && course.terms && course.terms.length > 0 && currentTerm.status == 1">本期未开始</ul-button>
            <ul-button type="primary" disabled v-if="course.isCharge && course.terms && course.terms.length > 0 && currentTerm.status == 3">本期已结束</ul-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="tabs-wrapper">
        <div class="tabs">
          <div class="tab" :class="{'is-active': tabIndex === 0}" @click="tabChange(0)">课程详情</div>
          <div class="tab" :class="{'is-active': tabIndex === 1}" @click="tabChange(1)">章节目录</div>
          <div class="tab" v-if="graphId" :class="{'is-active': tabIndex === 2}" @click="tabChange(2)">知识图谱</div>
        </div>
      </div>
      <div class="tab-content tab-detail" v-show="tabIndex === 0">
        <div class="course-section">
          <div class="section-title">课程简介</div>
          <richtext :content="termTextbook.description" :overflowHeight="200"></richtext>
        </div>
        <div class="course-section">
          <div class="section-title">课程团队</div>
          <ul class="member-list">
            <li v-for="item in termTextbook.textbookTeacherList" :key="item.id">
              <img :src="item.headimage | avatar" alt="">
              <div class="member-info">
                <div class="info">
                  <div class="name">{{item.name}}</div>
                  <!-- <div class="split">|</div> -->
                  <div class="school">{{item.orgname}}</div>
                </div>
                <!-- <div class="desc">{{item.introduction}}</div> -->
                <!-- <overflowHidden :content="getDescContent(item.introduction)"></overflowHidden> -->
                <richtext :content="getDescContent(item.introduction)"></richtext>
              </div>
            </li>
          </ul>
        </div>
        <div class="course-section" v-if="termTextbook.teachingOutline">
          <div class="section-title">教学大纲</div>
          <richtext :content="termTextbook.teachingOutline" :overflowHeight="200"></richtext>
        </div>
        <div class="course-section" v-if="termTextbook.bookName">
          <div class="section-title">推荐教材</div>
          <div class="textbook-wrapper">
            <img :src="termTextbook.bookCover" alt="" class="cover">
            <div class="textbook-info">
              <div class="title">{{termTextbook.bookName}}</div>
              <div class="info-item">作者：<span v-for="item in termTextbook.authorList" :key="item.coursebookUserId">{{item.userName}}</span></div>
              <div class="info-item">出版社：{{termTextbook.publishingHouse}}</div>
              <div class="info-item">ISBN：{{termTextbook.isbn}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="tab-content tab-index" v-show="tabIndex === 1">
        <ul class="chapter-list">
          <li v-for="chapter in termTextbook.chapterList" :key="chapter.id">
            <div class="chapter-item">
              <div class="chapter-title">{{chapter.name}}</div>
              <ul-button type="primary" round size="mini" v-if="chapter.audition" @click="preview(chapter.id)">去体验</ul-button>
            </div>
            <ul class="node-list">
              <li v-for="node in chapter.itemList" :key="node.id">
                <div class="dot"></div>
                <div class="node-title">{{node.name}}</div>
                <ul-button type="primary" round size="mini" v-if="!chapter.audition && node.audition" @click="preview(chapter.id, node.id)">去体验</ul-button>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="tab-content tab-graph" v-if="tabIndex === 2">
        <iframe :src="graphUrl" frameborder="0" v-if="graphFlag" ></iframe>
      </div>
    </div>
    <content-footer></content-footer>
    <ul-dialog
      title="选择班级"
      class="dialog-class"
      width="550px"
      :visible.sync="classDialogVisiable">
      <div class="label">请选择要加入的班级</div>
      <ul class="class-list">
        <li v-for="(item, index) in termForeignClassList" :key="index" :class="{'is-active': selectedForeignClass == item.classId}" @click="selectedForeignClass=item.classId">
          <div class="name">{{item.className}}</div>
          <div class="info">
            <span>教师：{{item.teacherNames.join('，')}}</span>
            <span>人数：{{item.studentCount}}</span>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="comfirmJoinForeignClass">确 定</ul-button>
        <ul-button plain @click="classDialogVisiable = false">取 消</ul-button>
      </span>
    </ul-dialog>
  </ul-page>
</template>

<script>
import { device } from '@/utils/device.js'
if (device.isMobile) {
  location.href = location.href.replace('pc.html', 'mobile.html')
}
import { mapGetters } from 'vuex'
import { 
  getTextbookInfo, 
  getTextbookDetail, 
  getTextbookOpen, 
  getTermForeignSchool, 
  joinTextbook, 
  getTermOcId, 
  getCourseMenu, 
  foreignerJoinClass, 
  relativeNetwork, 
} from '@/api/courseApi'
import { UMOOC_SERVER_HOST, KNOWLEDGE_GRAPH_WEB_HOST, UA_WEB_HOST, COURSE_WEB_HOST, UMOOC_WEB_HOST } from '@/config'
import avatar from '@/mixins/avatar.js'
import fullpath from '@/mixins/fullpath.js'
import richtext from 'pc/components/richtext.vue'
import overflowHidden from 'pc/components/overflowHidden.vue'
import { formatDate } from '@/utils'
import Confirm from 'pc/components/confirm'
import QRCode from 'qrcodejs2'
import contentFooter from 'pc/components/page/contentFooter.vue'
import cookies from '@/utils/cookie'
import 'mediaelement'
import 'mediaelement/build/mediaelementplayer.min.css'
import LoginUser from 'pc/components/page/user'
export default {
  name: 'page-course',
  mixins: [avatar, fullpath],
  data () {
    return {
      course: {},
      courseBg: '',
      qrcode: null,
      tabIndex: 0,
      currentTerm: {},
      copied: false,
      toTextbookMap: {
        '1': '进入课程',
        '2': '购买课程',
        '3': '加入课程'
      },
      termTextbook: {},
      termForeignClassList: [],  // 允许外校学生加入的班级
      selectedForeignClass: '', //待加入的外校班级
      classDialogVisiable: false,
      nationalQualityCourse: [3974, 8130, 3334, 3828, 3827, 9704, 8177, 8775, 3073, 1193, 8151, 9664, 8253, 9424, 8101, 7906, 11027, 9307, 8165],
      model2Types: ['#601a63', '#3a8de5', '#ee6a6a', '#456c96', '#874ea1', '#44899a', '#606b92', '#8d3f1e', '#5a6170', '#17a091', '#c8285e', '#3f51b5', '#7692e4', '#14103b', '#395547'],
      model3Types: ['#7676b1', '#3e80c6', '#ce6464', '#466687', '#7b4e90', '#467d8a', '#97a2b7', '#d19c6d', '#575d69', '#228f83', '#af2f5a', '#4250a0', '#6e84c6', '#627da4', '#41ac78'],
      graphUrl: null,
      graphId: null,
      graphFlag: false
    }
  },
  created () {
    this.getOpen()
  },
  mounted () {
    this.qrcode = new QRCode(this.$refs.qrCode, {
      text: this.textbookPortalUrl,
      width: 160,
      height: 160,
      colorDark: '#444444',
      colorLight: '#ffffff',
      correctLevel: QRCode.CorrectLevel.H
    })
  },
  computed: {
    ...mapGetters({'user': 'user/user', 'org': 'org/org'}),
    courseId () {
      return this.$route.params.id
    },
    toTextbookType () {
      if (this.user.userId) {
        // isOpen 1已开通  -1未开通  -2已过期
        if (this.course.isOpen == -1) {
          if (this.course.charge) {
            return 2 //'购买课程'
          }
          return 3 //'加入课程'
        }
        if (this.course.isOpen == 1 || this.course.isOpen == -2) {
          return 1 //'进入课程'
        }
      } else {
        if (this.course.charge) {
            return 2 //'购买课程'
          }
        return 3 //'加入课程'
      }
    },
    textbookPortalUrl () {
      if (!this.org.isMainSite) {
        return location.href
      }
      return `${UMOOC_SERVER_HOST}/course/${this.$route.params.id}`
    }
  },
  methods: {
    getKnowledgeGraph(id) {
      this.graphFlag = false
      relativeNetwork({textBookId: id})
      .then(({result}) => {
        this.graphFlag = true
        this.graphId = result
        if(result) {
          this.graphUrl = `${KNOWLEDGE_GRAPH_WEB_HOST}/pc.html#/graphPreview/${this.graphId}`
        } else {
          if (this.tabIndex == 2) {
            this.tabIndex = 0
          }
        }
      })
    },
    getOpen() {
      if (this.user.userId) {
        return getTextbookOpen(this.courseId)
          .then(({result}) => {
            this.course.isOpen = result
            this.getTextbookInfo()
            // return result
          })
      } else {
        // return  { result: -1 }
        this.course.isOpen = -1
        this.getTextbookInfo()
      }
    },
    getTextbookInfo () {
      getTextbookInfo(this.courseId)
        .then(({result}) => {
          document.title = result.name
          result.isCharge = Number(result.isCharge)
          result.terms = result.terms || []
          result.terms = result.terms.reverse()
          this.course = {...this.course, ...result}

          if (this.course.textbookId == 58124) {
            this.course.studentCount = 14744
            this.course.schoolCount = 29
          }
          if (result.terms && result.terms.length > 0) {
            this.currentTerm = result.terms[result.terms.length - 1]
            this.termChange()
          } else {
            this.getTextbookDetail(this.courseId)
            this.getKnowledgeGraph(this.courseId)
          }
          if (this.course.briefdesc) {
            this.$nextTick(() => {
              this.initVideo()
            })
          }
        })
    },
    getTextbookDetail (id) {
      getTextbookDetail(id)
        .then(({result}) => {
          this.termTextbook = result
        })
    },
    termTitle (item, index) {
      return `第${index + 1}次开课 ${formatDate(item.startTime, 'yyyy/MM/dd')} - ${formatDate(item.endTime, 'yyyy/MM/dd')}`
    },
    getTermStatusText () {
      if (this.currentTerm.status == 1) {
        return `距离开课还有${this.currentTerm.daysToGo}天`
      } else if (this.currentTerm.status == 2) {
        return `开课中`
        // ，本期选课人数：${this.currentTerm.studentNum}
      } else if (this.currentTerm.status == 3) {
        // return `本期选课人数：${this.currentTerm.studentNum}`
      }
    },
    termChange () {
      this.getTextbookDetail(this.currentTerm.textbookId)
      this.getKnowledgeGraph(this.currentTerm.textbookId)
    },
    toTextbook () {
      if (this.toTextbookType == 3) {
        if (!this.user.userId) {
          this.toLogin()
        } else {
          if (this.user.role == 8) {
            // 当前登录的是教师帐号，请切换到学生模式再加入课程！
            Confirm({
              content: '当前登录的是教师帐号，请切换到学生模式再加入课程！',
              confirmText: '切换到学生模式',
              onConfirm: this.switchRole
            })
          } else if (this.user.role == 9) {
            // 学生
            if (this.course.terms && this.course.terms.length > 0) {
              // 有学期
              if (this.user.orgId == this.course.orgId) {
                // 同校学生
                Confirm({
                  content: '本课程为同校教师开课，为避免成绩统计出现问题，请通过教师分享的班级编码或二维码加入。',
                  confirmText: '我知道了',
                  isShowCancel: false
                })
              } else {
                // 外校学生
                getTermForeignSchool({termId: this.currentTerm.id})
                  .then(({result}) => {
                    console.log(result)
                    if(result && result.length > 0) {
                      this.classDialogVisiable = true
                      this.termForeignClassList = result
                    } else {
                      // 无允许外校学生加入的班级  直接开通课件
                      this.joinTextbook()
                    }
                  })
              }
            } else {
              // 无学期 直接开通课件
              this.joinTextbook()
            }
            
          } else {
            // this.otherRoleDialog = true
            // 当前登录的不是学生帐号，请退出后使用学生帐号登录再加入课程！
            Confirm({
              content: '当前登录的不是学生帐号，请退出后使用学生帐号登录再加入课程！',
              confirmText: '退出登录',
              onConfirm: this.logout
            })
          }
        }
      } else if (this.toTextbookType == 1) {
        if (this.course.terms && this.course.terms.length > 0) {
          getTermOcId({ termId: this.currentTerm.id })
            .then(({result}) => {
              console.log(result)
              // result = 27162
              if (result) {
                this.toOcHomePage(result)
              } else {
                this.learnTextbook()
              }
            })
        } else {
          this.learnTextbook()
        }
      } else if (this.toTextbookType == 2) {
        if (!this.user.userId) {
          this.toLogin()
        } else {
          if (this.user.role == 8) {
            Confirm({
              content: '当前登录的是教师帐号，请切换到学生模式再购买！',
              confirmText: '切换到学生模式',
              onConfirm: this.switchRole
            })
          } else if (this.user.role == 9) {
            window.open(`${UMOOC_SERVER_HOST}/ulearning_web/web/product!immediatelyBuyCourse.do?productID=${this.courseId}`)
          } else {
            Confirm({
              content: '当前登录的不是学生帐号，请退出后使用学生帐号登录再购买！',
              confirmText: '退出登录',
              onConfirm: this.logout
            })
          }
        }
      }
    },
    comfirmJoinForeignClass () {
      if (!this.selectedForeignClass) {
        return
      }
      foreignerJoinClass(this.selectedForeignClass)
        .then(({result}) => {
          this.classDialogVisiable = false
          this.course.isOpen = 1
          Confirm({
            content: '加入成功！是否立即进入课程学习？',
            confirmText: '进入课程',
            onConfirm: () => {
              this.toOcHomePage(result)
            }
          })
        })
    },
    joinTextbook () {
      joinTextbook(this.courseId)
        .then((result) => {
          console.log(result)
          Confirm({
            content: '加入成功！是否立即进入课程学习？',
            confirmText: '进入课程',
            onConfirm: () => {
              this.learnTextbook()
            }
          })
        })
    },
    learnTextbook () {
      window.open(`${UA_WEB_HOST}/learnCourse/learnCourse.html?courseId=${this.courseId}&showExit=1`)
    },
    toOcHomePage (ocId) {
      getCourseMenu(ocId)
        .then(({result}) => {
          console.log(result)
          let hash = ''
          let menuId = 1
          let arr = result.filter(item => item.isHomepage)
          if (arr.length > 0) {
            menuId = arr[0].id
          }
          switch (menuId) {
            case 1:
              hash = 'announcement'
              break;
            case 2:
              hash = 'textbook'
              break;
            case 3:
              hash = 'resource'
              break;
            case 4:
              hash = 'homework'
              break;
            case 5:
              hash = 'discussion'
              break;
            case 6:
              hash = 'classroom'
              break;
            case 7:
              hash = 'live'
              break;
            case 8:
              hash = 'exam'
              break;
            default:
              hash = 'announcement'
          }
          let url = `${COURSE_WEB_HOST}/ulearning/index.html#/course/announcement?courseId=${ocId}`
          window.open(url)
        })
    },
    switchRole () {
      this.user.switchRole()
    },
    copyShareUrl () {
      var input = document.createElement('input');
      input.setAttribute('id', 'cp_hgz_input');
      input.value = this.textbookPortalUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.copied  = true
      setTimeout(() => {
        this.copied = false
      }, 1000)
    },
    getBg () {
      let model = this.course.backgroundModel || 1
      let type = this.course.backgroundType || 1
      // model = 2
      // type = 3
      let result = ''
      if (model == 1) {
        if (type == 1) {
          result = `${UMOOC_SERVER_HOST}/static/portal/images/course_preview/preview_bg.jpg`
        } else {
          result = `${UMOOC_SERVER_HOST}/static/portal/images/course_preview/model/model1/banner${type - 1}.jpg`
        }
        result = 'url(' + result + ')'
      } else if (model == 2) {
        return this.model2Types[type - 1]
      } else if (model == 2) {
        return this.model3Types[type - 1]
      }
      console.log(result)
      // this.courseBg = result
      return result
    },
    initVideo () {
      this.player = new MediaElementPlayer('video-media', {
        success: (mediaElement) => {
        },
        error: (event) => {
          console.log(event.detail)
          setTimeout(()=> {
             event.detail.target.parentElement.nextElementSibling.getElementsByClassName('mejs__cannotplay')[0].getElementsByTagName('a')[0].setAttribute('href','javascript:;')
          },300)
         
        }
      })
    },
    tabChange (index) {
      this.tabIndex = index
    },
    preview (chapterId, nodeId) {
      let url = `${UA_WEB_HOST}/learnCourse/learnCourse.html?courseId=${this.currentTerm.textbookId || this.courseId}&chapterId=${chapterId}${nodeId? ('&sectionId=' + nodeId) :''}&isPreview=true&isAudition=true&notQRcode=true`
      window.open(url)
    },
    getDescContent (str) {
      return str.replace(/\n|\r\n/g,"<br>")
    },
    logout () {
      this.user.logout()
    },
    toLogin () {
      cookies.set('loginRedirectUrl', location.href)
      this.$router.push({
        path: '/login'
      })
    }
  },
  components: {
    richtext,
    overflowHidden,
    contentFooter,
    LoginUser
  }
}
</script>

<style lang="scss" scoped>
.course-share{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 6px 18px 18px;
  .title{
    margin-bottom: 8px;
    font-size: 18px;
    line-height: 1;
    font-weight: bold;
  }
  .qrcode-wrapper{
    margin: 16px 0 12px 0;
    height: 160px;
    width: 160px;
  }
  .tips{
    color: $--color-text-secondary;
  }
  .url{
    margin-bottom: 8px;
  }
}
.page-course{
  .page-header-right {
    display: flex;
    align-items: center;
    
  }
  ::v-deep {
    .ul-page__body-content{
      width: 100%;
      background-color: inherit;
    }
  }
  .page-top{
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .page-top-shadow{
       padding: 32px 0;
       background-color: rgba(0,0,0,0.5);
    }
    .content{
      @include page-width;
    }
    .course-content{
      display: flex;
      padding:  24px;
      background-color: $--color-white;
      .cover-wrapper{
        position: relative;
        width: 480px;
        height: 270px;
      }
      .image-wrapper,.video-wrapper{
        height: 100%;
        width: 100%;
      }
      .national-flag{
        position: absolute;
        height: 48px;
      }
      .cover{
        height: 100%;
        width: 100%;
      }
      .course-info{
        display: flex;
        flex-direction: column;
        margin-left: 20px;
        flex: 1;
      }
      .title-wrapper{
        display: flex;
        .title{
          @include ellipsis2;
          max-width: 480px;
          height: 60px;
          line-height: 30px;
          font-size: 24px;
          font-weight: bold;
        }
        i{
          margin-left: 12px;
          font-size: 24px;
          line-height: 30px;
          cursor: pointer;
        }
      }
      .tags-wrapper{
        margin-top: 10px;
        .tag{
          display: inline-block;
          margin-right: 8px;
          padding: 0 4px;
          line-height: 18px;
          background: #FFF3D6;
          border-radius: 2px;
          border: 1px solid #E6C77C;
          font-size: 12px;
          color: #ce9d2b;
        }
      }
      .course-info-items{
        flex: 1;
        margin-top: 8px;
        .info-item{
          display: flex;
          padding: 2px 0;
          line-height: 24px;
          color: $--color-text-secondary;
          i{
            margin-right: 10px;
          }
          .item-content{
            flex: 1;
            @include ellipsis2;
          }
        }
      }
      .data-area{
        display: flex;
        justify-content: space-between;
        height: 74px;
        padding: 0 12px;
        background-color: #f8f8f8;
        .data-item{
          display: flex;
          align-items: center;
          padding: 0 12px;
          flex: 1;
          width: 0;
          .data-info{
            flex: 1;
            width: 0;
          }
          &>i{
            margin-right: 10px;
            font-size: 36px;
            color: $--color-primary;
          }
          .num{
            font-size: 18px;
            line-height: 26px;
          }
          .label{
            display: flex;
            font-size: 12px;
            line-height: 16px;
            color: $--color-text-secondary;
            .text{
              max-width: calc(100% - 20px);
              @include ellipsis2;
            }
            i{
              margin-left: 2px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .course-times{
      display: flex;
      padding: 20px 24px;
      margin-top: 22px;
      align-items: center;
      justify-content: space-between;
      background-color: $--color-white;
      .terms-wrapper{
        float: left;
      }
      .tips{
        color: $--color-text-secondary;
      }
      .ul-button{
        font-size: 16px;
      }
      .ul-select{
        width: 300px;
      }
      .status{
        display: inline-block;
        margin-left: 16px;
      }
      .ul-button{
        float: right;
      }
    }
  }
  .main-content{
    @include page-width;
    padding: 10px 0;
    background-color: $--color-white;
    margin: 32px auto;
    .tabs-wrapper{
      display: flex;
      justify-content: center;
      border-bottom: $--border-base;
    }
    .tabs{
      display: flex;
      .tab{
        padding: 10px 0;
        margin: 0 20px;
        line-height: 24px;
        font-size: 16px;
        cursor: pointer;
        &:hover{
          color: $--color-primary;
        }
        &.is-active{
          border-bottom: solid 3px $--color-primary;
          color: $--color-primary;
        }
      }
    }
    .course-section{
      padding: 20px 24px;
    }
    .section-title{
      padding: 0 8px;
      margin: 4px 0 20px;
      font-size: 18px;
      font-weight: bold;
      line-height: 1;
      border-left: solid 3px $--color-primary;
    }
    .member-list{
      li{
        display: flex;
        &:not(:last-child){
          margin-bottom: 32px;
        }
        img{
          width: 88px;
          height: 88px;
          border-radius: 100%;
          margin-right: 16px;
        }
        .member-info{
          flex: 1;
          width: 0;
          .info{
            display: flex;
            padding: 4px 0;
            margin-bottom: 8px;
            font-size: 16px;
            line-height: 1;
          }
          .name{
            padding-right: 10px;
            font-size: 18px;
            border-right: $--border-base;
            font-weight: bold;
          }
          .school{
            padding-left: 10px;
            font-size: 16px;
            line-height: 18px;
          }
          .desc{
            color: $--color-text-secondary;
          }
        }
      }
    }
    .textbook-wrapper{
      display:flex;
      .cover{
        width: 100px;
        height: 150px;
        margin-right: 16px;
        box-shadow: $--box-shadow-light;
      }
      .textbook-info{
        .title{
          margin-bottom: 16px;
          line-height: 26px;
          font-size: 18px;
          font-weight: bold;
        }
        .info-item{
          line-height: 28px;
        }
        span{
          margin-right: 4px;
        }
      }
    }
    .tab-index{
      padding: 24px;
      .chapter-list{
        .chapter-item{
          display: flex;
          align-items: center;
          padding: 12px 16px;
          background-color: #f8f8f8;
        }
        .chapter-title{
          flex: 1;
          line-height: 24px;
          font-size: 16px;
          font-weight: bold;
        }
      }
      .node-list{
        margin-left: 16px;
        padding-bottom: 24px;
        li{
          display: flex;
          align-items: center;
          padding: 12px 16px  12px 0;
          &:not(:last-child) {
            border-bottom: $--border-base;
          }
          .dot{
            height: 6px;
            width: 6px;
            margin-right: 8px;
            border-radius: 100%;
            background-color: #ccc;
          }
          .node-title{
            flex: 1;
            width: 0;
            line-height: 24px;
            font-size: 16px;
            // @include ellipsis;
          }
          
        }
      }
      .ul-button{
        margin-left: 16px;
      }
    }
    .tab-graph {
      padding: 20px 24px;
      width: 100%;
      height: 520px;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
  .dialog-class{
    .label{
      margin-bottom: 10px;
    }
    .class-list{
      li{
        margin-bottom: 10px;
        padding: 6px 10px;
        border-radius: 2px;
        border: dashed 1px $--border-color-base;
        cursor: pointer;
        .info{
          line-height: 18px;
          font-size: 12px;
          color: $--color-text-secondary;
          span{
            margin-right: 20px;
          }
        }
        &.is-active{
          border: solid 1px $--color-primary;
          background-color: rgba(234,89,71,0.1);
          color: $--color-primary;
          .info{
            color: $--color-primary;
          }
        }
      }
    }
  }
  // .ul-dialog{
  //   .ul-dialog__content{
  //     min-height: 72px;
  //   }
  //   .ul-button{
  //     width: 100%;
  //     margin-top: 16px;
  //     padding: 14px 20px;
  //   }
  //   .ul-button+.ul-button {
  //       margin-left: 0;
  //   }
  // }
}


</style>